// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoxDetail_wrapper__SRuT1","boxInfo":"BoxDetail_boxInfo__3vTJt","itemList":"BoxDetail_itemList__2g-44","loadMore":"BoxDetail_loadMore__1hgOG"};